import {ContainerTypeNamer} from "../dto/com.rico.sb2.support";

const containerTypeNamer = new ContainerTypeNamer();

export function containerTypeChar(ch: any) {
    const name = containerTypeNamer.name(ch);
    return name && name.length > 0 ? name[0] : '?';
}
